module.exports = __webpack_public_path__ + "img/3.5748fec6.jpg";